import React from 'react'
import OnVisible from 'react-on-visible'
import { Section, Image } from 'newComponents'
import { ReactComponent as Stars } from '../../images/home/quote-stars.svg'
import { ReactComponent as LeftStars } from '../../images/home/quote-stars-left.svg'
import { ReactComponent as RightStars } from '../../images/home/quote-stars-right.svg'
import { ReactComponent as BgStars } from '../../images/_background-stars/background-stars-right.svg'
import './styles.scss'

const CaseStudyQuote = (props) => {
  const { data } = props
  const { primary } = data
  const { author_image: authorImage, logo, title, author_name: name, author_role: role } = primary

  const hasImage = authorImage?.localFile || authorImage?.url
  const logoUrl = logo?.url
  const titleText = title?.text
  const nameHtml = name?.html
  const roleHtml = role?.html

  return (
    <OnVisible className="case-study-quote">
      <Section>
        {/* SVG BACKGROUND ICONS */}
        <Stars className="case-study-quote-stars" />
        <LeftStars className="case-study-quote-left-stars" />
        <RightStars className="case-study-quote-right-stars" />
        <BgStars className="case-study-quote-background-stars" />
        {/* QUOTE CONTAINER */}
        <div className="case-study-quote-container">
          {hasImage && (
            <div className="case-study-quote-image">
              <Image image={authorImage} />
            </div>
          )}
          {/* TEXT */}
          <div className="case-study-quote-body">
            {logoUrl && <Image image={logoUrl} className="case-study-quote-body-logo" />}
            <span className="case-study-quote-body-title">{titleText}</span>
            <div className="case-study-quote-author-container">
              {nameHtml && (
                <div className="case-study-quote-author-name" dangerouslySetInnerHTML={{ __html: nameHtml }} />
              )}
              {roleHtml && (
                <div className="case-study-quote-author-role" dangerouslySetInnerHTML={{ __html: roleHtml }} />
              )}
            </div>
          </div>
        </div>
      </Section>
    </OnVisible>
  )
}

export default CaseStudyQuote
